import { Helmet } from "react-helmet-async";
import Logo from './../assist/triokzzlohgo.svg';

export default function HomePageSEO() {

  // ── Structured Data ─────────────────────────────────────────

  // 1. WebSite — enables Google Sitelinks Search Box in SERPs
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Triokzz",
    alternateName: ["Triokzz Online Store", "Triokzz Shopping"],
    url: "https://www.triokzz.com",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate:
          "https://www.triokzz.com/search/?searchCategory=all&text={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  // 2. Organization — builds brand authority + logo in Knowledge Panel
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Triokzz",
    url: "https://www.triokzz.com",
    logo: {
      "@type": "ImageObject",
      url: Logo,
      width: 200,
      height: 60,
    },
    description:
      "Triokzz is an Indian online store offering authentic Paithani sarees, organic groceries, A2 bilona ghee, dry fruits, and personalised gifts. Free delivery above ₹1,449.",
    foundingDate: "2020",
    address: {
      "@type": "PostalAddress",
      streetAddress: "96, sai miracle, near eon west",
      addressLocality: "Pimpri-Chinchwad",
      addressRegion: "Maharashtra",
      addressCountry: "IN",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      availableLanguage: ["English", "Hindi", "Marathi"],
    },
    sameAs: [
      "https://www.instagram.com/triokzz?igsh=MWUzM3dweTNyY2NpeA==",
      "https://www.facebook.com/profile.php?id=61553460826080&mibexid=ZbWKwL",
      "https://x.com/triokzz",
      "https://www.linkedin.com/company/triokzz",
          "https://www.youtube.com/@TriokzzOnline"
      // add your actual social URLs here
    ],
  };

  // 3. ItemList — category grid as a navigational list
  // Helps Google understand your site structure from the homepage
  const siteNavigationSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Shop by Category — Triokzz",
    description: "Browse all product categories on Triokzz",
    url: "https://www.triokzz.com",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Kalanjali Paithani Sarees",
        url: "https://www.triokzz.com/product/womens",
        description:
          "Authentic handwoven Paithani sarees in aboli, green and chandrakor. Starting ₹2,159.",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Skin Care",
        url: "https://www.triokzz.com/product/skincare-cosmetics",
        description:
          "Buy organic Gheesutra face emmultion, kajal and kumkumadi oil online. A Thoughtful Marketplace for Authentic Skin Care Indian Essentials.",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Printed Mugs and desk mats",
        url: "https://www.triokzz.com/product/printed",
        description:
          "An artwork printed mug is a unique and creative product that features a piece of art printed on its surface",
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Decor objects and puja accessories",
        url: "https://www.triokzz.com/list/grocery/Dry-Fruits",
        description:
          "Buy from Centerpiece Table Decor items like 3 bowls platters to Orchard Aurum Heritage brass Mugs. pooja sets to candles.",
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "Personalised Gifts",
        url: "https://www.triokzz.com/product/personalized-gifts",
        description:
          "Custom mugs, t-shirts, travel bags and mouse pads. Perfect for birthdays and festivals.",
      },
    ],
  };

  // ── Meta content ────────────────────────────────────────────

  // Keyword-first title targeting highest-volume queries
  // Pattern: Primary keyword | Secondary keyword | Brand
  const metaTitle =
    "Triokzz — Paithani Sarees, Skin cares & Personalised Gifts and decor Online | Free Delivery India";

  // Description: lead with categories + free delivery signal + CTA
  // Under 155 chars
  const metaDesc = "Shop Kalanjali Paithani sarees, ghee sutra face wash, home and dinning decor & personalised gifts online. Free delivery above ₹1,449. Authentic products delivered pan-India.";

  const ogImage = "https://shopnowindia.s3.ap-south-1.amazonaws.com/triokzz.png"; // 1200x630px

  return (
    <Helmet>
      {/* ── Core meta ── */}
      {/* <title>{metaTitle}</title> */}
      {/* <meta name="description" content={metaDesc} /> */}
      <meta
        name="keywords"
        content="paithani saree online, kalanjali paithani, Decor objects, buy saree online india, Home decor items, Dinner set, Customised mugs, personalised gifts india, personalized items triokzz"
      />
      {/* <link rel="canonical" href="https://www.triokzz.com/" /> */}


      {/* ── Open Graph — optimised for WhatsApp sharing ── */}
      <meta property="fb:app_id" content="1800152527554298" />
      <meta property="og:site_name" content="Triokzz" />
      <meta property="og:locale" content="en_IN" />

      {/* ── Twitter Card ── */}
      <meta name="twitter:site" content="@Triokzz" />
      <meta name="twitter:url" content="https://www.triokzz.com/" />

      {/* ── Structured data ── */}
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(siteNavigationSchema)}
      </script>
    </Helmet>
  );
}